export interface BuildingValidationResponse {
  validationCode: ValidationCode;
  message: string;
  buildingNames: string[];
}

export enum ValidationCode {
  SUCCESS = 'SUCCESS',
  WARNING = 'WARNING',
  ERROR = 'ERROR'
}
